import React, { useState, useRef, useEffect, useContext } from "react";
import { Input, Grid } from 'semantic-ui-react'
import { Config } from "../common"
import moment from "moment";
import OwlCarousel from 'react-owl-carousel';
import searchicon from "../assets/home/searchicon.svg";
import { useSelector, useDispatch } from 'react-redux'
import { upcomingContestSlider, ContestList } from "../store/TriviaRedux"
import NoOrderHistory from "./NoOrderHistory";
import { useTranslation } from "react-i18next";
import Countdown from 'react-countdown';
import Loading from './Loading'
import InfiniteScroll from 'react-infinite-scroll-component';

const responsive = {
    0: {
        items: 2,
    },
    480: {
        items: 2,
    },
    768: {
        items: 3,
    }
}


const UpComing = ({ isSearch, isSlider }) => {
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation();
    const token = useSelector((state) => state.auth.token)
    const upcomings = useSelector((state) => state.trivia.upcomingContest)
    const contests = useSelector((state) => state.trivia.contests)
    const isFetching = useSelector((state) => state.trivia.isFetching)
    const [search, setSearch] = useState('')
    const [page, setPage] = useState(1)
    const timer = useRef();
    const [sliders, setSliders] = useState([])

    useEffect(() => {
        if (isSlider) {
            dispatch(upcomingContestSlider({ token }))
        } else {
            dispatch(ContestList({ status: 'upcoming', pageNo: 1, pageSize: 10, token }))
        }
    }, []);

    const handleSearch = (value) => {
        setSearch(value)
        let param = { status: 'upcoming', pageNo: 1, pageSize: 10, token }
        if (value) {
            param.title = value
        }
        clearInterval(timer.current);
        timer.current = setTimeout(() => {
            dispatch(ContestList(param))
        }, 500)
    }


    const fetchData = () => {
        if (contests.loadMore) {
            setPage(page + 1)
            let param = { status: 'upcoming', pageNo: page, pageSize: 10, token }
            if (search) {
                param.title = search
            }
            dispatch(ContestList(param))
        }
    }

    const refreshData = () => {

    }

    useEffect(() => {
        setSliders(JSON.parse(JSON.stringify(upcomings)))
    }, [i18n.language && upcomings]);


    const renderer = ({ days, hours, minutes, seconds }) => {
        return <ul>
            <li>{days}  <span>Days</span></li>
            <li>{hours} <span>Hours</span></li>
            <li>{minutes} <span>Mins</span></li>
        </ul>
    };



    return (
        <>
            {isSearch && (<div className="conten">
                <div className="input_box clearall">
                    <div className="search_sec">
                        <img className="searchicon" src={searchicon} />
                        <Input value={search} onChange={(e) => handleSearch(e.target.value)} placeholder='Search' />
                    </div>
                </div>
            </div>)}

            {isFetching && (<Loading />)}

            <div className="upcoming_sec clearall">
                {isSlider ? <>{sliders.length > 0 ? <OwlCarousel className='owl-theme' responsive={responsive} nav>
                    {sliders.map((item, key) => {
                        let basicDetails = Config.GetLanguage(item?.contest, i18n.language, 'basicDetails')
                        let newDate = moment.utc(item?.contest?.startDate) - moment.utc(Config.localUtc())
                        return <div key={key} className="sharma">
                            <div className="dummy">
                                <div className="bgupcming">
                                    <img src={item?.contest?.upcomingImage} />
                                    <h5>{basicDetails?.title}</h5>
                                    <Countdown date={Date.now() + newDate} renderer={renderer} />
                                </div>
                            </div>
                        </div>
                    })}
                </OwlCarousel> : null}</> : <Grid> <Grid.Row>
                    {(contests.data && contests.data.length > 0) ? contests.data.map((item, key) => {
                        let basicDetails = Config.GetLanguage(item, i18n.language, 'basicDetails')
                        let newDate = moment.utc(item?.startDate) - moment.utc(Config.localUtc())
                        return <Grid.Column key={key} mobile={8} tablet={8} computer={5}>
                            <div className="sharma">
                                <div className="dummy">
                                    <div className="bgupcming">
                                        <img src={item?.upcomingImage} />
                                        <h5>{basicDetails?.title}</h5>
                                        <Countdown date={Date.now() + newDate} renderer={renderer} />
                                    </div>
                                </div>
                            </div>
                        </Grid.Column>
                    }) : <NoOrderHistory />}
                </Grid.Row></Grid>}
            </div>
        </>
    );
};



export default UpComing;
